import type { KambiLiveData } from '@mobi/api-types/kambi'
import { getOrdinalSuffix } from '@mobi/utils/number/ordinal'

export function getBaseballInningText(score: KambiLiveData['score']) {
  if (!score.info) return '-'

  const inning = score.info
    .split('|')
    .map(part => part.trim())
    .filter(Boolean).length

  if (!inning) return '-'

  const inningText = `${inning}${getOrdinalSuffix(inning)}`

  if (score.who === 'AWAY') return `Top ${inningText}`
  if (score.who === 'HOME') return `Bot ${inningText}`

  return `Mid ${inningText}`
}
